import React, { FC } from "react";
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import {
  addressTextStyle2,
  addressTextStyle3,
  addressTextStyle4,
  headerBorderBottom,
  paymentCard,
  paymentTotal,
  paymentValues,
} from "./orderDetailsStyles";
import { Payment } from "../../dto/orderSummaryTypes";

const PaymentCard: FC<Payment> = ({
  status,
  method,
  subtotal,
  discount,
  shipping,
  exciseTotal,
  serviceTotal,
}) => {
  const details = [
    {
      title: "Excise Invoice Total",
      value: exciseTotal ? `Rs ${exciseTotal}` : "-",
    },
    {
      title: "Service Invoice Total",
      value: serviceTotal ? `Rs ${serviceTotal}` : "-",
    },
  ];

  const getTotal = () => {
    let total = 0;

    if (exciseTotal && serviceTotal) {
      total = exciseTotal + serviceTotal;
    }

    return total;
  };

  return (
    <Card sx={[paymentCard, { width: { xs: "100%", sm: "30%" } }]}>
      <CardHeader
        sx={headerBorderBottom}
        title={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box width="80px">
              <Typography sx={addressTextStyle3}>Payment</Typography>
              <Typography sx={[addressTextStyle4, { pb: 0 }]}></Typography>
            </Box>

            <Box
              sx={{
                borderLeft: "1px solid #E6E6E6",
                height: "40px",
                mx: "20px",
              }}
            />
            <Box>
              <Typography sx={[addressTextStyle4, { pb: 0 }]}>
                {status}
              </Typography>
            </Box>
          </Box>
        }
      />
      <CardContent
        sx={{
          py: "6px",
          px: "20px",
          "&:last-child": {
            paddingBottom: { xs: 0, sm: "24px" }, // Remove padding bottom from last child
          },
        }}
      >
        {details.map((detail, idx) => (
          <Box
            sx={[headerBorderBottom, { p: 0, m: 0 }]}
            key={idx}
            display="flex"
            justifyContent="space-between"
          >
            <Typography
              sx={[
                addressTextStyle2,
                { py: "12px", fontSize: "14px !important" },
              ]}
            >
              {detail.title}
            </Typography>
            <Typography sx={[paymentValues, { fontSize: "14px !important" }]}>
              {detail.value}
            </Typography>
          </Box>
        ))}
        <Box display="flex" justifyContent="space-between" mt="30px">
          <Typography sx={[paymentTotal, { fontWeight: 400 }]}>
            Total
          </Typography>
          {/* This value comes from order amount */}
          {/* <Typography sx={paymentTotal}>
            Rs {(parseInt(subtotal) / 100).toFixed(2)}
          </Typography> */}

          {/* This value comes from addition of excise invioce and service invoice */}
          <Typography sx={paymentTotal}>Rs {getTotal().toFixed(2)}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PaymentCard;
